import { render, staticRenderFns } from "./ModalCorrectInputJapanese.vue?vue&type=template&id=bf1e2152&scoped=true&lang=pug&"
import script from "./ModalCorrectInputJapanese.vue?vue&type=script&lang=ts&"
export * from "./ModalCorrectInputJapanese.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1e2152",
  null
  
)

export default component.exports